import { render } from "./UserNotification.vue?vue&type=template&id=587574b5&scoped=true"
import script from "./UserNotification.vue?vue&type=script&lang=js"
export * from "./UserNotification.vue?vue&type=script&lang=js"

import "./UserNotification.vue?vue&type=style&index=0&id=587574b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587574b5"]])

export default __exports__